


























































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { Account } from '@/modules/me';
import { School, OrdinarySchool } from '@/modules/school';
import { SchoolTypes, getSchoolTypeName } from '@/enums/schoolTypes';
import { TermTypes, getTermTypeName } from '@/enums/termTypes';
import { ElForm } from 'element-ui/types/form';
import { Subject } from '@/models/subject';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import store from '@/store';

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component
export default class SchoolEdit extends Vue {
  private SchoolTypes = SchoolTypes;
  private TermTypes = TermTypes;
  private FunctionTypes = FunctionTypes;
  private getSchoolTypeName = getSchoolTypeName;
  private getTermTypeName = getTermTypeName;

  private isSubjectEdit = true;
  private isOrdinarySchoolEdit = true;

  private predefineColors = [
    '#025ECE',
    '#02CE3F',
    '#02CE72',
    '#03CEA4',
    '#337093',
    '#338893',
    '#345995',
    '#573393',
    '#775558',
    '#7AF5F5',
    '#8A8CCE',
    '#8ABFCE',
    '#8ACEBB',
    '#8AEA35',
    '#A70EE8',
    '#AD9D27',
    '#C67D7F',
    '#CE0037',
    '#CE006A',
    '#CE009E',
    '#CE6300',
    '#D3C495',
    '#E4EA35',
    '#EA6935',
    '#EA9635',
    '#EAABBD',
    '#EAC435',
    '#F45D8A',
    '#F4B702',
    '#FF8787',
  ];

  private formSubjectRule = {
    name: [
      { required: true, message: '教科名を入力してください' },
    ],
  };

  private deleteSubjectRule = {
    checkSubjectName: [
      { required: true, message: '削除する教科名を入力してください' },
      { validator: this.validateCheckSubjectName, trigger: 'blur' },
    ],
  };

  private formOrdinarySchoolRule = {
    ordinarySchoolName: [
      { required: true, message: '学校名を入力してください' },
    ],
  };

  private deleteOrdinarySchoolRule = {
    checkOrdinarySchoolName: [
      { required: true, message: '削除する学校名を入力してください' },
      { validator: this.validateCheckOrdinarySchoolName, trigger: 'blur' },
    ],
  };

  private validateCheckSubjectName(rule: any, value: string, callback: any) {
    const subjectName = ((this.$refs.subjectDelete as DialogWrapper).form as any).subjectName;
    if (value.replace(/\s+/g, '') === subjectName.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('教科名が異なります'));
    }
  }

  private validateCheckOrdinarySchoolName(rule: any, value: string, callback: any) {
    const ordinarySchoolName = ((this.$refs.ordinarySchoolDelete as DialogWrapper).form as any).ordinarySchoolName;
    if (value.replace(/\s+/g, '') === ordinarySchoolName.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('学校名が異なります'));
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get user(): Account {
    return this.$store.state.me.user;
  }

  get loading(): boolean {
    return this.$store.state.school.loading;
  }

  get school(): School {
    return this.$store.state.school.school;
  }

  get availableFunction(): number {
    if (!this.user) {
      return 0;
    }
    return this.user.availableFunctionbit;
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['auth/userType']) {
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        next();
        break;
      default:
        next({ name: 'Error' });
        break;
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated(): void {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('school/fetchSchool');
  }

  private async onRegist() {
    try {
      await this.$confirm('スクール情報を変更します。よろしいですか？', 'スクール情報変更', {
        confirmButtonText: '変更',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('school/editSchool', this.school);
      this.$notify({
        title: 'スクール情報変更完了',
        message: 'スクール情報を変更しました。',
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'スクール情報変更エラー',
        message: error.message,
        position: 'bottom-right'
      });
      return;
    }

    this.$router.push({ name: 'Top' });
  }

  private onCancel() {
    this.$router.push({ name: 'Top' });
  }

  private submitSubjectForm() {
    (this.$refs.subjectForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.subjectEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async addSubject() {
    this.isSubjectEdit = false;

    const minId = Math.min.apply(null, this.school.subjectList.map((subject) => subject.id));
    const form: Subject = {
      id: minId < 0 ? minId - 1 : -1,
      name: '',
      color: '#000000'
    };

    try {
      const result = await (this.$refs.subjectEdit as DialogWrapper).open({...form}) as Subject;
      result.name = result.name.trim();

      if (!!this.school.subjectList.find((subject) => subject.name === result.name)) {
        this.$notify.error({
          title: '教科追加エラー',
          message: 'すでに同じ教科が存在します。',
          position: 'bottom-right'
        });
        return;
      }
      this.school.subjectList.push(result);
    } catch (error) {
      return;
    }
  }

  private async editSubject(index: number) {
    if (index < 0) {
      return;
    }

    this.isSubjectEdit = true;

    const row = this.school.subjectList[index];

    const form: Subject = JSON.parse(JSON.stringify(row));
    if (!form.color) {
      form.color = '#000000';
    }

    try {
      const result = await (this.$refs.subjectEdit as DialogWrapper).open({...form}) as Subject;
      this.school.subjectList.splice(index, 1, result);
    } catch (error) {
      return;
    }
  }

  private submitDeleteSubjectForm() {
    (this.$refs.deleteSubjectForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.subjectDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async deleteSubject(index: number) {
    if (index < 0) {
      return;
    }

    try {
      const row = this.school.subjectList[index];

      const form = {
        subjectName: row.name,
        checkSubjectName: '',
      };
      await (this.$refs.subjectDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    this.school.subjectList.splice(index, 1);
  }

  private submitOrdinarySchoolForm() {
    (this.$refs.ordinarySchoolForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.ordinarySchoolEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async addOrdinarySchool() {
    this.isOrdinarySchoolEdit = false;

    let minId: number = Math.min.apply(null,
      this.school.ordinarySchoolList
        .filter((item) => /^NewOrdinarySchool/.test(item.ordinarySchoolId))
        .map((item) => parseInt(item.ordinarySchoolId.replace('NewOrdinarySchool', ''), 10))
    );

    if (!minId || minId > 0) {
      minId = 0;
    }

    const form: OrdinarySchool = {
      ordinarySchoolId: `NewOrdinarySchool${minId - 1}`,
      ordinarySchoolName: '',
      schoolType: SchoolTypes.ElementarySchool,
      schoolTypeName: getSchoolTypeName(SchoolTypes.ElementarySchool),
      termType: TermTypes.Trimester,
      termTypeName: getTermTypeName(TermTypes.Trimester),
    };

    try {
      const result = await (this.$refs.ordinarySchoolEdit as DialogWrapper).open({...form}) as OrdinarySchool;

      if (!!this.school.ordinarySchoolList.find((sch) => sch.ordinarySchoolName === result.ordinarySchoolName)) {
        this.$notify.error({
          title: '学校追加エラー',
          message: 'すでに同じ学校が存在します。',
          position: 'bottom-right'
        });
        return;
      }

      this.school.ordinarySchoolList.push(result);
    } catch (error) {
      return;
    }
  }

  private async editOrdinarySchool(row: OrdinarySchool) {
    this.isOrdinarySchoolEdit = true;

    const form: OrdinarySchool = JSON.parse(JSON.stringify(row));

    try {
      const result = await (this.$refs.ordinarySchoolEdit as DialogWrapper).open({...form}) as OrdinarySchool;
      const findIndex = this.school.ordinarySchoolList.findIndex((value: OrdinarySchool) => {
        return (value.ordinarySchoolId === result.ordinarySchoolId);
      });
      if (findIndex >= 0) {
        this.school.ordinarySchoolList.splice(findIndex, 1, result);
      }
    } catch (error) {
      return;
    }
  }

  private submitDeleteOrdinarySchoolForm() {
    (this.$refs.deleteOrdinarySchoolForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.ordinarySchoolDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async deleteOrdinarySchool(row: OrdinarySchool) {
    try {
      const form = {
        ordinarySchoolName: row.ordinarySchoolName,
        checkOrdinarySchoolName: '',
      };
      await (this.$refs.ordinarySchoolDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    const findIndex = this.school.ordinarySchoolList.findIndex((value: OrdinarySchool) => {
      return (value.ordinarySchoolId === row.ordinarySchoolId);
    });
    if (findIndex >= 0) {
      this.school.ordinarySchoolList.splice(findIndex, 1);
    }
  }

  private onGradeAdvanceSetting() {
    this.$router.push({ name: 'GradeAdvanceSetting' });
  }
}
